import {Utils as BizkeytechUtils} from "../../../@bizkeytech";

/**
 * @inheritDoc
 */
class Utils extends BizkeytechUtils {
}

export * from "./type-declarations";
export default Utils;
